import { Routes, Route } from 'react-router-dom'
import UserDashboard from './dashboard'
import NewUser from './newUser'
import EditUser from './editUser'
import ConsumerDashboardUser from './consumer/dashboard'
import NewConsumerUser from './consumer/newConsumer'
import EditConsumerUser from './consumer/editConsumer'
import ViewConsumerUser from './consumer/viewConsumer'
import BillDashboardUser from './bill/dashboard'
import NewBillUser from './bill/newBill'
import ViewBillUser from './bill/viewBill'
import NewPaymentUser from './bill/newPayment'
import PaymentRecordUser from './bill/paymentRecord'




const UserRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<UserDashboard />} />
      <Route path="add-user" element={<NewUser />} />
      <Route path=":user" element={<EditUser/>} />

      <Route path="consumers" element={<ConsumerDashboardUser/>} />
      <Route path="consumers/add-consumer" element={<NewConsumerUser />} />
      <Route path="consumers/:consumer/edit" element={<EditConsumerUser />} />
      <Route path="consumers/:consumer/view" element={<ViewConsumerUser />} />

      <Route path="consumers/:consumer/bill" element={<BillDashboardUser />} />
      <Route path="consumers/:consumer/bill/new-bill" element={<NewBillUser />} />
      <Route path="consumers/:consumer/bill/:bill" element={<ViewBillUser />} />
      <Route path="consumers/:consumer/bill/:bill/new-payment" element={<NewPaymentUser />} />
      <Route path="consumers/:consumer/bill/:bill/payments" element={<PaymentRecordUser />} />
    </Routes>
  )
}

export default UserRoutes
